import React from "react";

export class LoginAnimationSvg extends React.Component<any, {}> {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio={"xMidYMid"} viewBox="0 0 1920 927">
        <g transform="translate(960,463.5) scale(1,1) translate(-960,-463.5)">
          <linearGradient id="lg-0.6084658314145286" x1="0" x2="1" y1="0" y2="0">
            <stop stopColor="#2f3451" offset="0"></stop>
            <stop stopColor="#c0a376" offset="1"></stop>
          </linearGradient>
          {Array.from({ length: 5 }).map((_, i) => (
            <path key={i} d="" fill="url(#lg-0.6084658314145286)" opacity="0.4">
              <animate
                attributeName="d"
                dur="33.333333333333336s"
                repeatCount="indefinite"
                keyTimes="0;0.333;0.667;1"
                calcMode="spline"
                keySplines="0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1"
                begin={`${-i * 6.666666666666667}s`}
                values={[
                  "M0 0L 0 778.9351026385217Q 192 668.4080022408335  384 636.0518611055326T 768 465.4585694627662T 1152 354.99655930939525T 1536 225.56788381458216T 1920 104.11509663196546L 1920 0 Z",
                  "M0 0L 0 857.6088340208685Q 192 796.284556234644  384 770.203583341513T 768 507.11431247067407T 1152 337.4405681779045T 1536 274.266258638179T 1920 63.84455823535086L 1920 0 Z",
                  "M0 0L 0 831.0562020892373Q 192 662.9092608993507  384 639.7318350184548T 768 604.380624529369T 1152 520.1742111746785T 1536 377.83285804401305T 1920 177.34871127078497L 1920 0 Z",
                  "M0 0L 0 778.9351026385217Q 192 668.4080022408335  384 636.0518611055326T 768 465.4585694627662T 1152 354.99655930939525T 1536 225.56788381458216T 1920 104.11509663196546L 1920 0 Z",
                ].join(";")}
              ></animate>
            </path>
          ))}
        </g>
      </svg>
    );
  }
}
